import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, logEvent as fbLogEvent } from "firebase/analytics";
import { RESEARCH_TYPE } from "./consts";

const firebaseConfig = {
  apiKey: "AIzaSyCsAjGyICjVHXQd7OdkMCXtJtu0lvhhX64",
  authDomain: "eals-asymp-participant-portal.firebaseapp.com",
  projectId: "eals-asymp-participant-portal",
  storageBucket: "eals-asymp-participant-portal.firebasestorage.app",
  messagingSenderId: "1049880903154",
  appId: "1:1049880903154:web:def10e41dc7e133787bf6b",
  measurementId: "G-1VRKP2GDBX",
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const analytics = getAnalytics(app);

// Disable gtag's automatic page_view on init — we track page views manually via RouteTracker
if (typeof window !== "undefined" && typeof window.gtag === "function") {
  window.gtag("config", firebaseConfig.measurementId, { send_page_view: false });
}

const PRODUCTION_HOST_BY_RESEARCH_TYPE = {
  "Asymptomatic Study": "asymptomatic.everythingals.org",
  "modality.ai": "speech.everythingals.org",
  "LE Study": "lestudy.everythingals.org",
  "ECAS Study": "ecas.everythingals.org",
};

const resolveEnvironment = () => {
  if (typeof window !== "undefined") {
    const host = window.location.hostname.toLowerCase();
    const productionHost = (
      PRODUCTION_HOST_BY_RESEARCH_TYPE[RESEARCH_TYPE] || ""
    ).toLowerCase();

    if (productionHost && host === productionHost) {
      return "production";
    }
    if (host === "localhost" || host === "127.0.0.1" || host.startsWith("dev")) {
      return "development";
    }
  }
  return process.env.NODE_ENV === "production" ? "production" : "development";
};

// research_type, user_name, environment, and debug_mode (dev only) are always injected
export function logEvent(eventName, params = {}) {
  fbLogEvent(analytics, eventName, {
    research_type: RESEARCH_TYPE,
    user_name: localStorage.getItem("ap_name") || "",
    environment: resolveEnvironment(),
    ...(process.env.NODE_ENV === "development" ? { debug_mode: false } : {}),
    ...params,
  });
}
